import React from "react";
import classNames from "classnames";
import { Link, useClasses } from "..";
const styles = (theme) => ({
    headline: {
        margin: "16px 0px 8px 0px",
    },
    section: {
        margin: "32px 0px 8px 0px",
        fontSize: "1rem",
        letterSpacing: "0.5px",
        textTransform: "uppercase",
        fontWeight: 600,
        color: theme.palette.get("section"),
    },
    link: {
        color: theme.palette.get("primary"),
        textDecoration: "none",
        "&:hover": {
            color: theme.palette.get("tertiary"),
        },
    },
    info: {
        margin: 0,
        color: theme.palette.get("darkGrey"),
        fontSize: "0.8rem",
        fontStyle: "italic",
    },
    paragraph: {
        margin: "8px 0px",
    },
    color: {
        color: (props) => props.color && theme.palette.get(props.color),
    },
});
export default function Typo(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const classes = useClasses(styles, props);
    const { variant } = props;
    const margin = props.margin === "none" ? 0 : props.margin;
    if (variant === "h1")
        return (React.createElement("h1", { className: classNames([
                classes.headline,
                classes.color,
                (_a = props.override) === null || _a === void 0 ? void 0 : _a.className,
            ]), style: { margin } }, props.children));
    if (variant === "h2")
        return (React.createElement("h2", { className: classNames([
                classes.headline,
                classes.color,
                (_b = props.override) === null || _b === void 0 ? void 0 : _b.className,
            ]), style: { margin } }, props.children));
    if (variant === "h3")
        return (React.createElement("h3", { className: classNames([
                classes.headline,
                classes.color,
                (_c = props.override) === null || _c === void 0 ? void 0 : _c.className,
            ]), style: { margin } }, props.children));
    if (variant === "h4")
        return (React.createElement("h4", { className: classNames([
                classes.headline,
                classes.color,
                (_d = props.override) === null || _d === void 0 ? void 0 : _d.className,
            ]), style: { margin } }, props.children));
    if (variant === "section")
        return (React.createElement("h4", { className: classNames([
                classes.section,
                classes.color,
                (_e = props.override) === null || _e === void 0 ? void 0 : _e.className,
            ]), style: { margin } }, props.children));
    if (variant === "a")
        return (React.createElement(Link, { to: props.to || "", className: classNames([
                classes.link,
                classes.color,
                (_f = props.override) === null || _f === void 0 ? void 0 : _f.className,
            ]), style: { margin } }, props.children));
    if (variant === "p")
        return (React.createElement("p", { className: classNames([
                classes.paragraph,
                classes.color,
                (_g = props.override) === null || _g === void 0 ? void 0 : _g.className,
            ]), style: { margin } }, props.children));
    if (variant === "info")
        return (React.createElement("span", { className: classNames([
                classes.info,
                classes.color,
                (_h = props.override) === null || _h === void 0 ? void 0 : _h.className,
            ]) }, props.children));
    throw Error("Unknown variant in Component Typo!");
}
